import superagent from 'superagent'

const programUser = program => {
  switch(program) {
    case 'qa_regtest':
      return process.env.REACT_APP_REGTEST_USER_NAME;
    case 'fasrewards':
      return process.env.REACT_APP_FASREWARDS_USER_NAME;
    case 'foodnfun':
      return process.env.REACT_APP_FOODNFUN_USER_NAME;
    case 'harts':
      return process.env.REACT_APP_HARTS_USER_NAME;
    case 'jacksons':
      return process.env.REACT_APP_JACKSONS_USER_NAME;
    case 'noco':
    case 'nocorewards':
      return process.env.REACT_APP_NOCO_USER_NAME;
    case 'kbrewards':
      return process.env.REACT_APP_KBREWARDS_USER_NAME;
    case 'sprintmart':
        return process.env.REACT_APP_SPRINTMART_USER_NAME;
    case 'mrgas':
        return process.env.REACT_APP_MRGAS_USER_NAME;
    case 'refuel':
        return process.env.REACT_APP_REFUEL_USER_NAME;
    case 'foodnfuel':
        return process.env.REACT_APP_FOODNFUEL_USER_NAME;
    case 'extramile':
        return process.env.REACT_APP_EXTRAMILE_USER_NAME;
    case 'quickstop':
        return process.env.REACT_APP_QUICKSTOP_USER_NAME;
    case 'millers':
        return process.env.REACT_APP_MILLERS_USER_NAME;
    case 'fleetway':
        return process.env.REACT_APP_FLEETWAY_USER_NAME;
    case 'rocket': // rocket is coalition subset of united
    case 'oasis': // oasis is a parentco in Coalition
    default:
      return process.env.REACT_APP_COALITION_USER_NAME;

  }
};

const programCompanyId = program => {
  switch(program) {
    case 'oasis':
      return process.env.REACT_APP_OASIS_ORG_LEVEL_ID;
    case 'rocket':
      return process.env.REACT_APP_ROCKET_ORG_LEVEL_ID;
    default:
        return null;
  }
};

const makeRequest = (cardnumber, program, pin, lastName, call) => {
  const username = programUser(program);
  const companyId = programCompanyId(program);
  let request = superagent.post(process.env.REACT_APP_API_RB_URL)
    .send(`user=${username}`)
    .send(`call=${call}`)
    .send(`cardnumber=${cardnumber}`)
    .send(`${companyId}`)

  if(pin) {
    request = request.send(`PIN=${pin}`);
  }
  if(lastName) {
    request = request.send(`LastName=${lastName}`);
  }
  return request;
}

export const fetchClubs = (cardnumber, program, pin, lastName) => {
  const call = 'get_card_club_status';
  return makeRequest(cardnumber, program, pin, lastName, call);
}



// WEBPACK FOOTER //
// ./src/store/apiCalls.js